// required because parcel cannot build inline js tags
function $773765e8bd6e9608$var$m(o, e) {
    if ([
        "link",
        "go"
    ].includes(o)) {
        if (e) {
            const t = document.querySelector(e);
            t ? t.scrollIntoView({
                behavior: "smooth",
                block: "start"
            }) : window.scrollTo({
                top: 0
            });
        } else window.scrollTo({
            top: 0
        });
    }
}
function $773765e8bd6e9608$var$u(o) {
    const e = new URL(o || window.location.href).href;
    return e.endsWith("/") || e.includes(".") || e.includes("#") ? e : `${e}/`;
}
function $773765e8bd6e9608$var$E(o) {
    (!window.history.state || window.history.state.url !== o) && window.history.pushState({
        url: o
    }, "internalLink", o);
}
function $773765e8bd6e9608$var$k(o) {
    document.querySelector(o).scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
}
function $773765e8bd6e9608$var$S(o) {
    const e = $773765e8bd6e9608$var$u();
    return {
        type: "popstate",
        next: e
    };
}
function $773765e8bd6e9608$var$F(o) {
    var t;
    let e;
    if (o.altKey || o.ctrlKey || o.metaKey || o.shiftKey) return {
        type: "disqualified"
    };
    for(let r = o.target; r.parentNode; r = r.parentNode)if (r.nodeName === "A") {
        e = r;
        break;
    }
    if (e && e.host !== location.host) return e.target = "_blank", {
        type: "external"
    };
    if (e && "cold" in (e == null ? void 0 : e.dataset)) return {
        type: "disqualified"
    };
    if (e != null && e.hasAttribute("href")) {
        const r = e.getAttribute("href"), n = new URL(r, location.href);
        if (o.preventDefault(), r != null && r.startsWith("#")) return $773765e8bd6e9608$var$k(r), {
            type: "scrolled"
        };
        const s = (t = r.match(/#([\w'-]+)\b/g)) == null ? void 0 : t[0], i = $773765e8bd6e9608$var$u(n.href), c = $773765e8bd6e9608$var$u();
        return {
            type: "link",
            next: i,
            prev: c,
            scrollId: s
        };
    } else return {
        type: "noop"
    };
}
function $773765e8bd6e9608$var$N(o) {
    return new DOMParser().parseFromString(o, "text/html");
}
function $773765e8bd6e9608$var$g(o) {
    document.body.querySelectorAll("[flamethrower-preserve]").forEach((t)=>{
        let r = o.body.querySelector('[flamethrower-preserve][id="' + t.id + '"]');
        if (r) {
            const n = t.cloneNode(!0);
            r.replaceWith(n);
        }
    }), document.body.replaceWith(o.body);
}
function $773765e8bd6e9608$var$A(o) {
    const e = (i)=>Array.from(i.querySelectorAll('head>:not([rel="prefetch"]')), t = e(document), r = e(o), { staleNodes: n, freshNodes: s } = $773765e8bd6e9608$var$L(t, r);
    n.forEach((i)=>i.remove()), document.head.append(...s);
}
function $773765e8bd6e9608$var$L(o, e) {
    const t = [], r = [];
    let n = 0, s = 0;
    for(; n < o.length || s < e.length;){
        const i = o[n], c = e[s];
        if (i != null && i.isEqualNode(c)) {
            n++, s++;
            continue;
        }
        const a = i ? r.findIndex((l)=>l.isEqualNode(i)) : -1;
        if (a !== -1) {
            r.splice(a, 1), n++;
            continue;
        }
        const h = c ? t.findIndex((l)=>l.isEqualNode(c)) : -1;
        if (h !== -1) {
            t.splice(h, 1), s++;
            continue;
        }
        i && t.push(i), c && r.push(c), n++, s++;
    }
    return {
        staleNodes: t,
        freshNodes: r
    };
}
function $773765e8bd6e9608$var$b() {
    document.head.querySelectorAll("[data-reload]").forEach($773765e8bd6e9608$var$v), document.body.querySelectorAll("script").forEach($773765e8bd6e9608$var$v);
}
function $773765e8bd6e9608$var$v(o) {
    const e = document.createElement("script"), t = Array.from(o.attributes);
    for (const { name: r, value: n } of t)e[r] = n;
    e.append(o.textContent), o.replaceWith(e);
}
const $773765e8bd6e9608$var$x = {
    log: !1,
    pageTransitions: !1
};
class $773765e8bd6e9608$var$q {
    constructor(e){
        this.opts = e, this.enabled = !0, this.prefetched = /* @__PURE__ */ new Set(), this.opts = {
            ...$773765e8bd6e9608$var$x,
            ...e != null ? e : {}
        }, window != null && window.history ? (document.addEventListener("click", (t)=>this.onClick(t)), window.addEventListener("popstate", (t)=>this.onPop(t)), this.prefetch()) : (console.warn("flamethrower router not supported in this browser or environment"), this.enabled = !1);
    }
    go(e) {
        const t = window.location.href, r = new URL(e, location.origin).href;
        return this.reconstructDOM({
            type: "go",
            next: r,
            prev: t
        });
    }
    back() {
        window.history.back();
    }
    forward() {
        window.history.forward();
    }
    get allLinks() {
        return Array.from(document.links).filter((e)=>e.href.includes(document.location.origin) && !e.href.includes("#") && e.href !== (document.location.href || document.location.href + "/") && !this.prefetched.has(e.href));
    }
    log(...e) {
        this.opts.log && console.log(...e);
    }
    prefetch() {
        if (this.opts.prefetch === "visible") this.prefetchVisible();
        else if (this.opts.prefetch === "hover") this.prefetchOnHover();
        else return;
    }
    prefetchOnHover() {
        this.allLinks.forEach((e)=>{
            const t = e.getAttribute("href");
            e.addEventListener("pointerenter", ()=>this.createLink(t), {
                once: !0
            });
        });
    }
    prefetchVisible() {
        const e = {
            root: null,
            rootMargin: "0px",
            threshold: 1
        };
        "IntersectionObserver" in window && (this.observer || (this.observer = new IntersectionObserver((t, r)=>{
            t.forEach((n)=>{
                const s = n.target.getAttribute("href");
                if (this.prefetched.has(s)) {
                    r.unobserve(n.target);
                    return;
                }
                n.isIntersecting && (this.createLink(s), r.unobserve(n.target));
            });
        }, e)), this.allLinks.forEach((t)=>this.observer.observe(t)));
    }
    createLink(e) {
        const t = document.createElement("link");
        t.rel = "prefetch", t.href = e, t.as = "document", t.onload = ()=>this.log("\uD83C\uDF29\uFE0F prefetched", e), t.onerror = (r)=>this.log("\uD83E\uDD15 can't prefetch", e, r), document.head.appendChild(t), this.prefetched.add(e);
    }
    onClick(e) {
        this.reconstructDOM($773765e8bd6e9608$var$F(e));
    }
    onPop(e) {
        this.reconstructDOM($773765e8bd6e9608$var$S());
    }
    async reconstructDOM({ type: e, next: t, prev: r, scrollId: n }) {
        if (!this.enabled) {
            this.log("router disabled");
            return;
        }
        try {
            if (this.log("\u26A1", e), [
                "popstate",
                "link",
                "go"
            ].includes(e) && t !== r) {
                this.opts.log && console.time("\u23F1\uFE0F"), window.dispatchEvent(new CustomEvent("flamethrower:router:fetch")), e != "popstate" && $773765e8bd6e9608$var$E(t);
                const i = await (await fetch(t, {
                    headers: {
                        "X-Flamethrower": "1"
                    }
                }).then((a)=>{
                    const h = a.body.getReader(), l = parseInt(a.headers.get("Content-Length"));
                    let d = 0;
                    return new ReadableStream({
                        start (f) {
                            function p() {
                                h.read().then(({ done: y, value: w })=>{
                                    if (y) {
                                        f.close();
                                        return;
                                    }
                                    d += w.length, window.dispatchEvent(new CustomEvent("flamethrower:router:fetch-progress", {
                                        detail: {
                                            progress: Number.isNaN(l) ? 0 : d / l * 100,
                                            received: d,
                                            length: l || 0
                                        }
                                    })), f.enqueue(w), p();
                                });
                            }
                            p();
                        }
                    });
                }).then((a)=>new Response(a, {
                        headers: {
                            "Content-Type": "text/html"
                        }
                    }))).text(), c = $773765e8bd6e9608$var$N(i);
                $773765e8bd6e9608$var$A(c), this.opts.pageTransitions && document.createDocumentTransition ? document.createDocumentTransition().start(()=>{
                    $773765e8bd6e9608$var$g(c), $773765e8bd6e9608$var$b(), $773765e8bd6e9608$var$m(e, n);
                }) : ($773765e8bd6e9608$var$g(c), $773765e8bd6e9608$var$b(), $773765e8bd6e9608$var$m(e, n)), window.dispatchEvent(new CustomEvent("flamethrower:router:end")), setTimeout(()=>{
                    this.prefetch();
                }, 200), this.opts.log && console.timeEnd("\u23F1\uFE0F");
            }
        } catch (s) {
            return window.dispatchEvent(new CustomEvent("flamethrower:router:error", s)), this.opts.log && console.timeEnd("\u23F1\uFE0F"), console.error("\uD83D\uDCA5 router fetch failed", s), !1;
        }
    }
}
const $773765e8bd6e9608$export$2e2bcd8739ae039 = (o)=>{
    const e = new $773765e8bd6e9608$var$q(o);
    if (o.log && console.log("\uD83D\uDD25 flamethrower engaged"), window) {
        const t = window;
        t.flamethrower = e;
    }
    return e;
};


const $dad545c909cfec2d$var$router = (0, $773765e8bd6e9608$export$2e2bcd8739ae039)({
    prefetch: "visible",
    log: false,
    pageTransitions: false
});
// loading bar
window.addEventListener("flamethrower:router:fetch-progress", ({ detail: detail })=>{
    const progressBar = document.getElementById("load");
    progressBar.style.width = detail.progress + "%";
});
const $dad545c909cfec2d$var$burgers = function() {
    var burger = document.querySelector(".nav-toggle");
    var menu = document.querySelector(".nav-menu");
    console.log(burger);
    burger.addEventListener("click", function() {
        burger.classList.toggle("is-active");
        menu.classList.toggle("is-active");
    });
};
$dad545c909cfec2d$var$burgers();
window.addEventListener("flamethrower:router:end", ()=>{
    $dad545c909cfec2d$var$burgers();
});


//# sourceMappingURL=index.bd01759b.js.map
